import { AppHeader, Avatar, IconButton } from '@nike/eds'
import { NikeApp } from '@nike/nike-design-system-icons'
import { useLogoutMutation, useWhoAmIQuery } from 'api/authentication'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export function Header () {
  const { t } = useTranslation()
  const [logout, { isSuccess: isLoggedOut }] = useLogoutMutation()
  const { data: user, isLoading } = useWhoAmIQuery()
  const [initials, setInitials] = useState('-')

  const params = new URLSearchParams(window.location.search)
  const station = params.get('unitHandlingStation')!
  const dpiVersion = params.get('dpiVersion') ?? '300'
  const queryParams = `?unitHandlingStation=${encodeURIComponent(station)}&dpiVersion=${encodeURIComponent(dpiVersion)}`

  useEffect(() => {
    if (isLoading || !user || !user.isAuthenticated) {
      return
    }
    setInitials(user.firstName[0] + user.lastName[0])
  }, [user])

  useEffect(() => {
    if (isLoggedOut) {
      setInitials('-')
      window.dispatchEvent(new Event('logout'))
    }
  }, [isLoggedOut])

  return (
    <AppHeader style={{ height: '48px' }}
      isDark
      appName={t('app_name')}
      logoSlot={
        <Link reloadDocument to={`/${queryParams}`} aria-label='logo-link'>
          <NikeApp
            color={'white'}
            width={'56px'}
            height={'64px'}
            style={{ marginTop: '6px' }}
          />
        </Link>
      }
      toolbarSlot={
        <div></div>
      }
      avatarSlot={
        <>
          <Avatar initials={initials} size={36} />
          <IconButton
            icon="Close"
            label="quit"
            variant="secondary"
            size="small"
            onClick={() => { logout() }}
            className="eds-color--text-secondary"
          />
        </>
      }
    />
  )
}
